export const msgsConstants = {
    offlineBanner: "You're offline. Some features may not be available.",
    onlineBanner: "You're back online!",
    networkErrorTitle: "Connection Error",
    networkErrorDescription: "Unable to connect to the server. Please check your internet connection and try again.",
    stackErrorTitle: "Something Went Wrong",
    stackErrorDescription: "An unexpected error occurred. The error has been logged and our team will look into it.",
};
